{
  "AllNotifications": "所有通知",
  "NoLinkNotification": "沒有此通知的連結",
  "ViewAllAnnouncementTab": "公告",
  "ViewallNotificationTab": "通知",
  "preferences": "編輯偏好設定"
}
